var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45118 12.0202C1.4448 6.18622 6.16944 1.45175 12.0035 1.44537C13.7745 1.44707 15.517 1.89441 17.0697 2.74618C22.1802 5.54956 24.0495 11.9643 21.2466 17.0747C18.4437 22.1852 12.028 24.0549 6.91802 21.2521L1.94058 22.062L2.75052 17.0846C1.89949 15.5322 1.45267 13.7906 1.45118 12.0202Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6035 6.2412H6.72698C6.59196 6.24624 6.46407 6.30313 6.36991 6.40004C6.27575 6.49694 6.22255 6.62641 6.22139 6.76152C5.3564 13.9381 10.4797 18.9126 17.2562 17.7963C17.3845 17.7904 17.5059 17.7367 17.5967 17.6459C17.6875 17.5551 17.7411 17.4337 17.7471 17.3055V14.4289C17.7411 14.3007 17.6875 14.1793 17.5967 14.0885C17.5059 13.9977 17.3845 13.944 17.2562 13.9381C16.6016 13.9542 15.95 13.8442 15.3369 13.6141C14.8558 13.4472 14.63 13.4472 14.1392 13.9381L13.1574 14.9444C12.2871 14.4869 11.4965 13.8918 10.8159 13.1821C10.1177 12.4961 9.53426 11.7022 9.08808 10.8309L10.0944 9.84911C10.2834 9.72181 10.4202 9.53065 10.4797 9.31066C10.5392 9.09067 10.5174 8.8566 10.4183 8.65138C10.1883 8.03831 10.0783 7.3867 10.0944 6.73207C10.0944 6.60188 10.0426 6.47702 9.95059 6.38497C9.85854 6.29291 9.73368 6.2412 9.6035 6.2412Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.1b71fd85f264281d12c22032976d6f3c.svg";
export { ForwardRef as ReactComponent };